const calculateTutorialVideoComponentSize = (isIPadProSize: boolean) => {
  if (isIPadProSize) {
    return { videoWidth: 200 };
  } else {
    return { videoWidth: 150 };
  }
};

export default calculateTutorialVideoComponentSize;
